import {Action, ActionReducerMap} from '@ngrx/store';
import * as actionsUi from './inicident-abteilungsleitstelle.actions.ui';
import {
    GET_ABTEILUNG_EINGANG2,
    GET_ABTEILUNG_EINGANG2_ERFOLGREICH,
    GET_ABTEILUNG_EINGANG2_FEHLER,
    GET_ABTEILUNG_LISTE2,
    GET_ABTEILUNG_LISTE2_ERFOLGREICH,
    GET_ABTEILUNG_LISTE2_FEHLER,
    GET_ABTEILUNG_PINNWAND2, GET_ABTEILUNG_PINNWAND2_ERFOLGREICH, GET_ABTEILUNG_PINNWAND2_FEHLER,
    GET_INCIDENT_BILD_IDS,
    GET_INCIDENT_BILD_IDS_ERFOLGREICH,
    GET_INCIDENT_BILD_IDS_FEHLER,
    GET_INCIDENT_DETAIL,
    GET_INCIDENT_DETAIL_ERFOLGREICH,
    GET_INCIDENT_DETAIL_FEHLER,
    GetAbteilungEingang2ErfolgreichAction,
    GetAbteilungListe2ErfolgreichAction,
    GetAbteilungPinnwand2ErfolgreichAction,
    GetIncidentBildIdsErfolgreichAction,
    GetIncidentBildIdsFehlerAction,
    GetIncidentDetailAction,
    GetIncidentDetailErfolgreichAction,
    GetIncidentDetailFehlerAction,
    POST_INCIDENT_MELDUNG_AKTUALISIEREN
} from '../../../client-ngrx/incidents';
import {IncidentBildsIds, IncidentDetail, IncidentKopf, VerlaufEintrag} from '../../../clients/incidents';
import {IncidentsListResponse} from '../../../clients/incidents';
import {
    INCIDENT_AUSGEWAEHLT,
    IncidentAusgewaehltAction, MELDUNG_AUSGEWAEHLT, MeldungAusgewaehltAction,
    SETZE_ABGESCHLOSSENE_ANZEIGEN,
    SETZE_DELEGATION_ROLLE,
    SETZE_FUNKTIONSBEREICHS_ID, SETZE_LETZTE_MELDUNGEN_ANZEIGEN,
    SETZE_LETZTE_SYSTEM_MELDUNGEN_ANZEIGEN,
    SETZE_PINNWAND_AKTIV,
    SETZE_VERANSTALTUNGSRELEVANT,
    SETZE_VERANTWORTUNG_ABTEILUNG,
    SETZE_VERANTWORTUNG_ZENTRAL, SetzeAbgeschlosseneAnzeigenAction,
    SetzeDelegationRolleAction,
    SetzeFunktionsbereichsIdAction, SetzeLetzteMeldungenAnzeigenAction,
    SetzeLetzteSystemMeldungenAnzeigenAction,
    SetzePinnwandAktivAction,
    SetzeVeranstaltungsrelevantAction,
    SetzeVerantwortungAbteilungAction,
    SetzeVerantwortungZentralAction
} from './inicident-abteilungsleitstelle.actions.ui';
import {VeranstaltungSelektionLocalData} from '../veranstaltungsselection/veranstaltungselektion.model';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    funktionsbereichId: string;

    eingangLaden: boolean;
    eingangFehler: boolean;
    eingang: Array<IncidentKopf>;

    listeLaden: boolean;
    listeFehler: boolean;
    liste: IncidentsListResponse;

    pinnwandLaden: boolean;
    pinnwandFehler: boolean;
    pinnwand: Array<IncidentKopf>;

    selectedIncident: IncidentKopf;

    incidentDetailOriginal: IncidentDetail;
    incidentDetail: IncidentDetail;
    incidentDetailLaden: boolean;
    incidentDetailFehler: boolean;

    incidentBildIds: IncidentBildsIds;
    incidentBildIdsLaden: boolean;
    incidentBildIdsFehler: boolean;

    selectedMeldung: VerlaufEintrag;

    abgeschlosseneAnzeigen: boolean;
    letzteMeldungenAnzeigen: boolean;
    letzteSystemMeldungenAnzeigen: boolean;

    localData: VeranstaltungSelektionLocalData;
}

export const initialPageState: PageState = {
    funktionsbereichId: '',

    eingangLaden: false,
    eingangFehler: false,
    eingang: [],

    listeLaden: false,
    listeFehler: false,
    liste: null,

    pinnwandLaden: false,
    pinnwandFehler: false,
    pinnwand: [],

    selectedIncident: null,

    incidentDetailOriginal: null,
    incidentDetail: null,
    incidentDetailLaden: false,
    incidentDetailFehler: false,

    incidentBildIds: null,
    incidentBildIdsLaden: false,
    incidentBildIdsFehler: false,

    selectedMeldung: null,

    abgeschlosseneAnzeigen: false,
    letzteMeldungenAnzeigen: true,
    letzteSystemMeldungenAnzeigen: false,

    localData: null

};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState, <PageState> {
                funktionsbereichId: state.funktionsbereichId
            });
        }

        // Funktionsbereich-ID
        case SETZE_FUNKTIONSBEREICHS_ID: {
            const a = <SetzeFunktionsbereichsIdAction> action;

            return Object.assign({}, state, <PageState> {
                funktionsbereichId: a.payload
            });
        }

        // Zentrale Eingang lesen
        case GET_ABTEILUNG_EINGANG2: {
            return Object.assign({}, state, <PageState> {
                eingangLaden: true,
                eingangFehler: false
            });
        }

        case GET_ABTEILUNG_EINGANG2_ERFOLGREICH: {
            const a = <GetAbteilungEingang2ErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                eingangLaden: false,
                eingangFehler: false,
                eingang: a.payload
            });
        }

        case GET_ABTEILUNG_EINGANG2_FEHLER: {
            return Object.assign({}, state, <PageState> {
                eingangLaden: false,
                eingangFehler: true,
                eingang: []
            });
        }

        // Zentrale Liste
        case GET_ABTEILUNG_LISTE2: {
            return Object.assign({}, state, <PageState> {
                listeLaden: true,
                listeFehler: false
            });
        }

        case GET_ABTEILUNG_LISTE2_ERFOLGREICH: {
            const a = <GetAbteilungListe2ErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                listeLaden: false,
                listeFehler: false,
                liste: a.payload
            });
        }

        case GET_ABTEILUNG_LISTE2_FEHLER: {
            return Object.assign({}, state, <PageState> {
                listeLaden: false,
                listeFehler: true,
                liste: null
            });
        }

        // Pinnwand
        case GET_ABTEILUNG_PINNWAND2: {
            return Object.assign({}, state, <PageState> {
                pinnwandLaden: true,
                pinnwandFehler: false
            });
        }

        case GET_ABTEILUNG_PINNWAND2_ERFOLGREICH: {
            const a = <GetAbteilungPinnwand2ErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                pinnwandLaden: false,
                pinnwandFehler: false,
                pinnwand: a.payload
            });
        }

        case GET_ABTEILUNG_PINNWAND2_FEHLER: {
            return Object.assign({}, state, <PageState> {
                pinnwandLaden: false,
                pinnwandFehler: true,
                pinnwand: []
            });
        }

        // selektiertes Indicent setzen
        case INCIDENT_AUSGEWAEHLT: {
            const a = <IncidentAusgewaehltAction>action;

            let incidentDetail = Object.assign({}, state.incidentDetail);
            let incidentDetailOriginal = Object.assign({}, state.incidentDetailOriginal);

            if (a.payload === null) {
                incidentDetail = null;
                incidentDetailOriginal = null;
            }

            return Object.assign({}, state, <PageState> {
                selectedIncident: a.payload,
                incidentDetail,
                incidentDetailOriginal,
                selectedMeldung: null
            });
        }

        // IncidentDetail
        case GET_INCIDENT_DETAIL: {
            const a = <GetIncidentDetailAction>action;
            const selectedIncident = Object.assign({}, state.selectedIncident);

            if (selectedIncident.incident_id === a.incident_id) {
                return Object.assign({}, state, <PageState>{
                    incidentDetailLaden: true,
                    incidentDetailFehler: false
                });
            } else {
                return state;
            }
        }

        case GET_INCIDENT_DETAIL_ERFOLGREICH: {
            const a = <GetIncidentDetailErfolgreichAction> action;

            const selectedIncident = Object.assign({}, state.selectedIncident);

            if (selectedIncident.incident_id === a.payload.incident_id) {
                const incidentDetailOriginal = Object.assign({}, a.payload);

                return Object.assign({}, state, <PageState> {
                    incidentDetailLaden: false,
                    incidentDetailFehler: false,
                    incidentDetail: a.payload,
                    incidentDetailOriginal
                });
            } else {
                return state;
            }


        }

        case GET_INCIDENT_DETAIL_FEHLER: {
            const a = <GetIncidentDetailFehlerAction>action;
            const selectedIncident = Object.assign({}, state.selectedIncident);

            if (selectedIncident.incident_id === a.incident_id) {
                return Object.assign({}, state, <PageState>{
                    incidentDetailLaden: false,
                    incidentDetailFehler: true,
                    incidentDetail: null
                });
            } else {
                return state;
            }
        }

        // IncidentBildIds
        case GET_INCIDENT_BILD_IDS: {
            const a = <GetIncidentDetailAction>action;
            const selectedIncident = Object.assign({}, state.selectedIncident);

            if (selectedIncident.incident_id === a.incident_id) {
                return Object.assign({}, state, <PageState>{
                    incidentBildIdsLaden: true,
                    incidentBildIdsFehler: false
                });
            } else {
                return state;
            }
        }

        case GET_INCIDENT_BILD_IDS_ERFOLGREICH: {
            const a = <GetIncidentBildIdsErfolgreichAction> action;

            const selectedIncident = Object.assign({}, state.selectedIncident);

            if (selectedIncident.incident_id === a.payload.incident_id) {
                return Object.assign({}, state, <PageState> {
                    incidentBildIdsLaden: false,
                    incidentBildIdsFehler: false,
                    incidentBildIds: a.payload
                });
            } else {
                return state;
            }
        }

        case GET_INCIDENT_BILD_IDS_FEHLER: {
            const a = <GetIncidentBildIdsFehlerAction>action;
            const selectedIncident = Object.assign({}, state.selectedIncident);

            if (selectedIncident.incident_id === a.incident_id) {
                return Object.assign({}, state, <PageState>{
                    incidentBildIdsLaden: false,
                    incidentBildIdsFehler: true,
                    incidentBildIds: null
                });
            } else {
                return state;
            }
        }

        // Detail-Properties setzen
        case SETZE_VERANSTALTUNGSRELEVANT: {
            const a = <SetzeVeranstaltungsrelevantAction>action;

            const incidentDetail = Object.assign({}, state.incidentDetail);
            incidentDetail.ist_veranstaltungsrelevant = a.payload;

            return Object.assign({}, state, <PageState> {
                incidentDetail
            });
        }

        case SETZE_VERANTWORTUNG_ZENTRAL: {
            const a = <SetzeVerantwortungZentralAction>action;

            const incidentDetail = Object.assign({}, state.incidentDetail);
            incidentDetail.ist_verantwortlichkeit_zentrale = a.payload;
            incidentDetail.ist_verantwortlichkeit_abteilung = !a.payload;
            if (!a.payload) {
                incidentDetail.verantwortlichkeit_funktionsbereich_id = null;
                incidentDetail.delegation_rolle_id = null;
                incidentDetail.delegation_funktionsbereich_id = null;
            }

            return Object.assign({}, state, <PageState> {
                incidentDetail
            });
        }

        case SETZE_VERANTWORTUNG_ABTEILUNG: {
            const a = <SetzeVerantwortungAbteilungAction>action;

            const incidentDetail = Object.assign({}, state.incidentDetail);
            incidentDetail.ist_verantwortlichkeit_zentrale = false;
            incidentDetail.ist_verantwortlichkeit_abteilung = true;
            incidentDetail.verantwortlichkeit_funktionsbereich_id = a.payload;
            incidentDetail.delegation_rolle_id = null;
            incidentDetail.delegation_funktionsbereich_id = null;

            return Object.assign({}, state, <PageState> {
                incidentDetail
            });
        }

        case SETZE_DELEGATION_ROLLE: {
            const a = <SetzeDelegationRolleAction>action;

            const incidentDetail = Object.assign({}, state.incidentDetail);
            incidentDetail.delegation_rolle_id = a.payload.rolle_id;
            incidentDetail.delegation_funktionsbereich_id = a.payload.funktionsbereich_id;

            return Object.assign({}, state, <PageState> {
                incidentDetail
            });
        }

        case SETZE_PINNWAND_AKTIV: {
            const a = <SetzePinnwandAktivAction>action;

            const incidentDetail = Object.assign({}, state.incidentDetail);
            incidentDetail.ist_pinnwand_aktiv = a.payload;

            return Object.assign({}, state, <PageState> {
                incidentDetail
            });
        }

        case MELDUNG_AUSGEWAEHLT: {
            const a = <MeldungAusgewaehltAction>action;

            return Object.assign({}, state, <PageState> {
                selectedMeldung: a.payload
            });
        }

        case SETZE_ABGESCHLOSSENE_ANZEIGEN: {
            const a = <SetzeAbgeschlosseneAnzeigenAction> action;

            return Object.assign({}, state, <PageState> {
                abgeschlosseneAnzeigen: a.payload
            });
        }

        case POST_INCIDENT_MELDUNG_AKTUALISIEREN: {
            return Object.assign({}, state, <PageState> {
                selectedMeldung: null
            });
        }

        case SETZE_LETZTE_MELDUNGEN_ANZEIGEN: {
            const a = <SetzeLetzteMeldungenAnzeigenAction> action;

            return Object.assign({}, state, <PageState> {
                letzteMeldungenAnzeigen: a.payload
            });
        }

        case SETZE_LETZTE_SYSTEM_MELDUNGEN_ANZEIGEN: {
            const a = <SetzeLetzteSystemMeldungenAnzeigenAction> action;

            return Object.assign({}, state, <PageState> {
                letzteSystemMeldungenAnzeigen: a.payload
            });
        }

        case actionsUi.SETZE_VERANSTALTUNG_SELEKTION_LOCAL_DATA: {
            const a = <actionsUi.SetzeVeranstaltungSelektionLocalDataAction> action;

            const localData = Object.assign({}, state.localData, a.payload);

            return Object.assign({}, state, <PageState> {
                localData
            });
        }

        default: {
            return state;
        }
    }
}
